import { lazy, ReactElement } from 'react';

// Auth
const ButLogout = lazy(() => import('@/components/Auth/ButLogout'));

// Dashboard  
const DashOne = lazy(() => import('@/views/DashOne'));

// Admin
const PanelAdministration = lazy(() => import('@/views/Admin/PanelAdministration'));
const PanelUtilisateur = lazy(() => import('@/views/Admin/PanelUtilisateur'));
const UsersList = lazy(() => import('@/views/Users/UsersList'));

// Local (Biens)
const LocalHome = lazy(() => import('@/views/Local/LocalHome'));
const LocalAdd = lazy(() => import('@/views/Local/LocalAdd'));
const LocalEdl = lazy(() => import('@/views/Local/LocalEdl'));
/* const LocalFluide = lazy(() => import('@/views/Local/LocalFluide')); */

// Rent (Locations)
const RentAdd = lazy(() => import('@/views/Rent/RentAdd'));
const RentHome = lazy(() => import('@/views/Rent/RentHome'));
const AugLoyer = lazy(() => import('@/views/Rent/AugLoyer'));
const FinContrat = lazy(() => import('@/views/Rent/FinContrat'));

// Charges
const Charge = lazy(() => import('@/views/Charge/Charge'));

// États & Documents
const Impression = lazy(() => import('@/views/Etat/Impression'));
const Courrier = lazy(() => import('@/views/Etat/Courrier'));
const EnvoiCourrier = lazy(() => import('@/views/Etat/EnvoiCourrier'));

// Tenant (Locataires)
const TenantsPayment = lazy(() => import('@/views/Tenant/TenantsPayment'));
const TenantHome = lazy(() => import('@/views/Tenant/TenantHome'));
const TenantAdd = lazy(() => import('@/views/Tenant/TenantAdd'));
const TenantsFluide = lazy(() => import('@/views/Tenant/TenantsFluide'));
const LocalsFluide = lazy(() => import('@/views/Tenant/LocalsFluide'));

// Finance
const FinanceHome = lazy(() => import('@/views/Finance/FinanceHome'));
const ResByRent = lazy(() => import('@/views/Finance/ResByRent'));
const ResByProv = lazy(() => import('@/views/Finance/ResByProv'));
const ResMensuel = lazy(() => import('@/views/Finance/ResMensuel'));
const Credit = lazy(() => import('@/views/Finance/Credit'));
const BilanGlobal = lazy(() => import('@/views/Finance/BilanGlobal'));
const ResultatFiscal = lazy(() => import('@/views/Finance/ResultatFiscal'));
const SimulateurFiscal = lazy(() => import('@/views/Finance/SimulateurFiscal'));

// Signalements
const SignalementHome = lazy(() => import('@/views/Signalement/SignalementHome'));

// Work (Travaux)
const WorkHome = lazy(() => import('@/views/Work/WorkHome'));
const WorkerHome = lazy(() => import('@/views/Worker/WorkerHome'));
const WorkAdd = lazy(() => import('@/views/Work/WorkAdd'));
const WorkListTodo = lazy(() => import('@/views/Work/WorkListTodo'));

// Artisan & Supplier - CORRIGÉ: components/ au lieu de views/
const ArtisanNew = lazy(() => import('@/components/Artisan/ArtisanNew'));
const ListCard = lazy(() => import('@/components/Supplier/ListCard'));

// Room & Lease
/* const RoomEdl = lazy(() => import('@/views/Room/RoomEdl')); */
const LeaseEdl = lazy(() => import('@/views/Lease/LeaseEdl'));

export interface RouteConfig {
  path: string;
  name?: string;
  element: ReactElement;
}

export const appRoutes: RouteConfig[] = [
  { path: '/', name: 'Accueil', element: <DashOne /> },
  { path: '/home', name: 'Home', element: <DashOne /> },
  { path: '/Dashone', name: 'Synthèse', element: <DashOne /> },
  { path: '/dashboard', name: 'Tableau de bord', element: <DashOne /> },
  { path: '/logout', name: 'Déconnexion', element: <ButLogout /> },
  
  // Admin
  { path: '/Administrateur', name: 'Administration', element: <PanelAdministration /> },
  { path: '/MonEspace', name: 'Mon espace', element: <PanelUtilisateur /> },
  { path: '/Users/UsersList', name: 'Utilisateurs', element: <UsersList /> },
  
  // Locaux
  { path: '/Local/LocalHome', name: 'Accueil Local', element: <LocalHome /> },
  { path: '/Local/LocalAdd', name: 'Ajouter Local', element: <LocalAdd /> },
  { path: '/Local/LocalEdl', name: 'États des lieux', element: <LocalEdl /> },
/*   { path: '/Local/LocalFluide', name: 'Relevés', element: <LocalFluide /> },
   */
  // Locations
  { path: '/Rent/RentAdd', name: 'Ajouter Location', element: <RentAdd /> },
  { path: '/Rent/RentHome', name: 'Accueil Location', element: <RentHome /> },
  { path: '/Rent/AugLoyer', name: 'Augmentation loyer', element: <AugLoyer /> },
  { path: '/Rent/FinContrat', name: 'Fin de bail', element: <FinContrat /> },
  
  // Charges
  { path: '/Charge/Charge', name: 'Gestion Charges', element: <Charge /> },
  
  // Documents
  { path: '/Etat/Impression', name: 'Impression', element: <Impression /> },
  { path: '/Etat/Courrier', name: 'Courrier', element: <Courrier /> },
  { path: '/Etat/EnvoiCourrier', name: 'Envoi automatisé', element: <EnvoiCourrier /> },
  
  // Locataires
  { path: '/Tenant/TenantsPayment', name: 'Paiements', element: <TenantsPayment /> },
  { path: '/Tenant/TenantHome', name: 'Accueil Locataire', element: <TenantHome /> },
  { path: '/Tenant/TenantAdd', name: 'Ajouter Locataire', element: <TenantAdd /> },
  { path: '/Tenant/TenantsFluide', name: 'Fluides locataire', element: <TenantsFluide /> },
  { path: '/Tenant/LocalsFluide', name: 'Fluides bien', element: <LocalsFluide /> },
  
  // Finance
  { path: '/Finance/FinanceHome', name: 'Accueil Finance', element: <FinanceHome /> },
  { path: '/Finance/ResByRent', name: 'Résultat par location', element: <ResByRent /> },
  { path: '/Finance/ResByProv', name: 'Résultat par provision', element: <ResByProv /> },
  { path: '/Finance/ResMensuel', name: 'Tableau mensuel', element: <ResMensuel /> },
  { path: '/Finance/Credit', name: 'Crédit', element: <Credit /> },
  { path: '/Finance/BilanGlobal', name: 'Bilan global', element: <BilanGlobal /> },
  { path: '/Finance/ResultatFiscal', name: 'Résultat fiscal', element: <ResultatFiscal /> },
  { path: '/Finance/SimulateurFiscal', name: 'Simulateur fiscal', element: <SimulateurFiscal /> },
  
  // Signalements
  { path: '/Signalement/SignalementHome', name: 'Signalements', element: <SignalementHome /> },

  // Travaux
  { path: '/Work/WorkHome', name: 'Devis/Facture', element: <WorkHome /> },
  { path: '/Worker/WorkerHome', name: 'Accueil Travaux', element: <WorkerHome /> },
  { path: '/Work/WorkAdd', name: 'Ajouter Travaux', element: <WorkAdd /> },
  { path: '/Work/WorkListTodo', name: 'Liste travaux', element: <WorkListTodo /> },
  
  // Fournisseurs
  { path: '/Artisan/ArtisanNew', name: 'Ajout artisan', element: <ArtisanNew /> },
  { path: '/Supplier/ListCard', name: 'Liste fournisseurs', element: <ListCard /> },
  
  // Room & Lease
 /*  { path: '/Room/RoomEdl', name: 'État des lieux pièces', element: <RoomEdl /> }, */
  { path: '/Lease/LeaseEdl', name: 'État des lieux bail', element: <LeaseEdl /> },
];

export default appRoutes;